import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import * as Sentry from '@sentry/angular';
import { HttpErrorResponse } from '@angular/common/http';

if (environment.enableSentry) {
  Sentry.init({
    dsn: environment.sentryDSN,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: environment.production ? 0.2 : 1.0,
    environment: environment.envPlaceholder,
    denyUrls: [/localhost/],
    beforeSend(event, hint) {
      const error = hint.originalException;
      // Ignore 401 errors
      if (
        typeof error === 'string' &&
        error.includes('Http failure response')
      ) {
        // Parse the string to identify status 401 if possible
        if (error.includes('401')) {
          return null;
        }
      }
      if (error instanceof HttpErrorResponse && error.status === 401) {
        return null;
      }
      return event;
    },
  });
}

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
